<template>
	<el-dialog v-model="show" :show-close="false" width="80%" top="10vh" @open="open" :destroy-on-close="true"
		@close="closeDialog">
		<div class="i">
			<div class="title-box">
				<div class="title-right-box" @click="closeDialog">
					<p class="iconfont icon-shang"></p>
					<span>收起采购单</span>
				</div>
			</div>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="直接购买" name="0">
					<div class="i-content">
						<div class="i-title-left">
							<el-form 
								ref="ruleForm"
								:model="ruleForm"
								:rules="rules"
								label-width="100px"
							>
								<el-row>
									<el-col :span="8">
										<el-form-item label="收货人:" prop="consigneeName">
											<el-input v-model="ruleForm.consigneeName" placeholder="请输入收货人" :disabled="isEdit"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="收货人电话:" prop="consigneePhone">
											<el-input v-model="ruleForm.consigneePhone" placeholder="请输入收货人电话" :disabled="isEdit"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="默认地址:">
											<el-radio-group v-model="ruleForm.defaultFlag" :disabled="isEdit">
												<el-radio label="0">否</el-radio>
												<el-radio label="1">是</el-radio>
											</el-radio-group>
										</el-form-item>
										
									</el-col>
									<el-col :span="8">
										<el-form-item label="省市区:" prop="value">
											<el-cascader
												v-model="ruleForm.value"
												:options="areaInfo"
												:props="{ expandTrigger: 'hover' }"
												@change="handleChange"
												style="width: 100%;"
												:disabled="isEdit"
											></el-cascader>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="详细地址:" prop="address">
											<el-input v-model="ruleForm.address" placeholder="例如**街道**号**栋**室" :disabled="isEdit"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<el-form-item label="公司名字:" prop="company">
											<el-input v-model="ruleForm.company" placeholder="请输入公司名称" :disabled="isEdit"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="22" style="text-align: right;">
										<el-button type="primary" @click="saveAddress">保存</el-button>
									</el-col>
									<el-col :span="2">
										<div style="line-height: 35px; padding-left: 15px;">
											<el-popover
												class="box-item"
												:width="500"
												title="请选择地址"
												placement="bottom-end"
												v-model:visible="showVisible"
											>
												<template #reference><el-button type="primary" icon="el-icon-arrow-down">选择地址</el-button></template>
												<div>
													<div class="ra-list" v-for="(item,index) in list" :key="index">
														<div class="ra-row">
															<el-row>
																<el-col :span="20">
																	<div style="line-height: 40px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" class="ellipsis">
																		{{item.consigneeName}}（{{item.consigneePhone}}）
																		<span>
																			{{item.province}}-{{item.city}}-{{item.district}} {{item.address}}
																		</span>
																		<el-tag 
																			effect="dark" 
																			v-if="item.defaultFlag === '1'" 
																			style="margin-left: 10px;"
																			size="mini">默认</el-tag>
																	</div>
																</el-col>
																<el-col :span="4">
																	<el-button type="text" @click="chooseAddress(item)">选择</el-button>
																</el-col>
															</el-row>
															
														</div>
													</div>
													<div class="ra-row">
														<el-row>
															<el-col :span="24"><el-button icon="el-icon-plus" size="small" style="width: 100%;" @click="addNewAddress">新增地址</el-button></el-col>
														</el-row>
													</div>
												</div>
											</el-popover>	
										</div>
									</el-col>
								</el-row>
								<!-- <el-row>
									<el-col :span="24">
										<el-form-item label="备注:">
											<el-input :rows="3" type="textarea" v-model="ruleForm.remarks" :disabled="isEdit"></el-input>
										</el-form-item>
									</el-col>
								</el-row> -->
							</el-form>
							<el-button @click="createOrder" type="primary" size="mini">生成采购单</el-button>
						</div>
						<!-- 商品信息 -->
						<lida-table height="calc(100% - 40px)" :pagination="false" :cutHeight="getHeight" :data="tableData"
							border ref="table">
							<lida-table-column label="产品信息">
								<template #default="scope">
									<div class="g-info">
										<div class="g-icon">
											<img :src="scope.row.src" />
										</div>
										<div class="g-right">
											<div class="g-r-title">
												{{ scope.row.productName }}
												<div class="label" :title="scope.row.brandName">{{ scope.row.brandName }}
												</div>
											</div>
											<div class="g-r-data">
												{{ scope.row.barCode || '无' }}
												<span>|</span>
												{{ scope.row.seriesName || '无' }}
												<span>|</span>
												{{ scope.row.skuNumber || '无' }}
											</div>
										</div>
									</div>
								</template>
							</lida-table-column>
							<lida-table-column label="订货号" prop="articleNo" />
							<lida-table-column label="面价" prop="guidePrice" />
							<lida-table-column label="报价数量" prop="qty" />
							<lida-table-column label="采购数量" prop="purchaseQty" :width="240">
								<template #default="scope">
									<el-input-number @change="num => numChange(num, scope.row)"
										v-model="scope.row.purchaseQty" :min="1" :max="99999999" />
								</template>
							</lida-table-column>
							<lida-table-column label="采购单价" prop="purchasePrice" />
							<lida-table-column label="发货地区" prop="shipArea" />
							<lida-table-column label="渠道" prop="channel" />
							<lida-table-column label="是否过保" prop="isExpire" />
							<lida-table-column label="操作" fixed="right">
								<template #default="scope">
									<el-button size="mini" @click="deleteRow(scope.row)" type="text">移除</el-button>
								</template>
							</lida-table-column>
						</lida-table>
					</div>
				</el-tab-pane>
				<el-tab-pane label="平台购买" name="1">
					<div class="i-content">
						<div class="i-title-left">
							<el-button @click="platformPurchase" type="primary" size="mini">平台代购</el-button>
						</div>
						<!-- 商品信息 -->
						<lida-table height="calc(100% - 50px)" :pagination="false" :cutHeight="getHeight" :data="tableData"
							border ref="table2">
							<lida-table-column label="产品信息">
								<template #default="scope">
									<div class="g-info">
										<div class="g-icon">
											<img :src="scope.row.src" />
										</div>
										<div class="g-right">
											<div class="g-r-title">
												{{ scope.row.productName }}
												<div class="label" :title="scope.row.brandName">{{ scope.row.brandName }}
												</div>
											</div>
											<div class="g-r-data">
												{{ scope.row.barCode || '无' }}
												<span>|</span>
												{{ scope.row.seriesName || '无' }}
												<span>|</span>
												{{ scope.row.skuNumber || '无' }}
											</div>
										</div>
									</div>
								</template>
							</lida-table-column>
							<lida-table-column label="订货号" prop="articleNo" />
							<lida-table-column label="面价" prop="guidePrice" />
							<lida-table-column label="报价数量" prop="qty" />
							<lida-table-column label="采购数量" prop="purchaseQty" :width="240">
								<template #default="scope">
									<el-input-number @change="num => numChange(num, scope.row)"
										v-model="scope.row.purchaseQty" :min="1" :max="99999999" />
								</template>
							</lida-table-column>
							<lida-table-column label="采购单价" prop="purchasePrice" />
							<lida-table-column label="发货地区" prop="shipArea" />
							<lida-table-column label="渠道" prop="channel" />
							<lida-table-column label="是否过保" prop="isExpire" />
							<lida-table-column label="操作" fixed="right">
								<template #default="scope">
									<el-button size="mini" @click="deleteRow(scope.row)" type="text">移除</el-button>
								</template>
							</lida-table-column>
						</lida-table>
					</div>
				</el-tab-pane>
			</el-tabs>
			<!-- <div class="i-title">
				<div class="i-title-left">
					<el-button @click="createOrder" type="primary" size="mini">生成采购单</el-button>
				</div>
				<div class="i-title-right" @click="closeDialog">
					<p class="iconfont icon-shang"></p>
					<span>收起采购单</span>
				</div>
			</div> -->
		</div>
	</el-dialog>
</template>

<script>
import area from "@/common/json/area.json"
import { ElMessage } from 'element-plus'
import { mapActions } from 'vuex'
import { handleTreeData } from "@/common/js/common.js"
export default {
	data() {
		return {
			activeName: '0',
			tableData: [],
			list:[],
			areaInfo:handleTreeData(area,'name','name'),
			showVisible: true,
			type: "add",
			ruleForm:{  //表单数据
				id: 0,
				value:'',  //地址数据
				address:'',  //详细地址
				consigneeName:'',  //收货人
				consigneePhone:'',  //收货人电话
				remarks:'',  //备注
				defaultFlag:'0',  //是否是收货地址
				company:'', //公司名称
			},
			rules:{  //验证数据
				value:[
					{required: true,message: '请选择归属地',trigger: 'change'}
				],
				address:[
					{required: true,message: '请输入详细地址',trigger: 'blur'}
				],
				consigneeName:[
					{required: true,message: '请输入收货人',trigger: 'blur'}
				],
				consigneePhone:[
					{required: true,message: '请输入收货人电话',trigger: 'blur'}
				]
			}
		}
	},
	props: {
		modelValue: Boolean,
		data: Array,
		inquiryId: String,
	},
	created() {
		// this.tableData = this.data
		// console.log(this.data);
		this.activeName = '0'
		if (this.tableData.length === 0) {
			this.handleClick('0')
		}
		const params = {
			inquiryId: this.inquiryId,
			type: this.activeName
		}
		// this.tableData = []
		this.purchaseCartListCart(params).then(res => {
			let { data, code } = res.data;
			if (code === '0') {
				this.tableData = data;
			}
		})
		this.getList();
	},
	methods: {
		...mapActions('purchaseMudule', [
			'purchaseCartCreatePurchase',  //生成采购单
			'userConsigneeList',
			'purchaseCartUpdate',   //修改购物车商品信息
			'purchaseCartListCart', // 采购购物车列表 查列表
			'purchaseCartCreatePurchaseAdmin', // 生成采购单(平台采购)
			'editUserConsignee',  //修改地址
			'addUserConsignee',  //新增收货地址
		]),
		closeDialog() { //关闭弹框
			this.$emit('update:modelValue', false);
		},
		deleteRow(row) { //删除row的事件
			this.$emit("delete", row);
			// console.log(row);
			// this.handleClick(this.activeName)
			this.tableData.forEach((v, i) => {
				// console.log(v,i);
				this.tableData.splice(i, 1)
			});
		},
		close() { //关闭弹框
			this.$emit('update:modelValue', false);
		},
		createOrder() {
			let validate = true;
			this.$refs['ruleForm'].validate((valid) => {
				if(valid){
					this.saveAddress();
				}else{
					validate = false; 
				}
			})

			if(!validate){
				return
			}
			
			var data = JSON.parse(JSON.stringify(this.tableData));
			if (data.length) {
				this.purchaseCartCreatePurchase({inquiryId: this.inquiryId, addressId: this.ruleForm.id}).then(res => {
					let { code, data } = res.data;
					if (code === '0') {
						ElMessage({
							type: 'success',
							message: '生成采购单成功',
						});
						debugger
						this.close();
						this.$emit('success');
						this.$router.push({
							path: "/mysale/xinOrderDetails",
							query: {
								id: data.documentId,
								type: "_purchase",
								inquiryId: this.inquiryId
							},
          				});
					}
				})
			} else {
				ElMessage({
					type: 'warning',
					message: '请选择要生成采购单的商品',
				})
			}
		},
		numChange(num, row) { //改变数量的事件
			this.purchaseCartUpdate({
				...row,
				purchaseQty: num,
			}).then(res => {
				let { code, data } = res.data;
				if (code === '0') { }
			})
		},
		// 切换 tab
		handleClick(val) {
			const params = {
				inquiryId: this.inquiryId,
				type: this.activeName
			}
			// this.tableData = []
			this.purchaseCartListCart(params).then(res => {
				let { data, code } = res.data;
				if (code === '0') {
					this.tableData = data;
				}
			})
		},
		// 平台购买
		platformPurchase() {
			// console.log(this.tableData)
			const list = JSON.parse(JSON.stringify(this.tableData))
			const params = {
				inquiryId: this.inquiryId,
				purchaseCartItemVOList: list
			}
			console.log(params, list, '----')
			if (this.tableData.length) {
				this.purchaseCartCreatePurchaseAdmin(params).then(res => {
					let { code, data } = res.data;
					if (code === '0') {
						ElMessage({
							type: 'success',
							message: '生成平台代购成功',
						})
						this.close();
						this.$emit('success');
					}
				})
			} else {
				ElMessage({
					type: 'warning',
					message: '请选择要生成平台代购的商品',
				})
			}
		},
		//选择收货地址
		chooseAddress(address){
			this.type = "edit";
			this.showVisible = true;
			address.value = [
				address.province,
				address.city,
				address.district
			]
			this.ruleForm = address;
			this.showVisible = false;
		},
		//添加新地址
		addNewAddress(){
			this.type = "add";
			this.showVisible = true;
			this.ruleForm = {  //表单数据
				value:'',  //地址数据
				address:'',  //详细地址
				consigneeName:'',  //收货人
				consigneePhone:'',  //收货人电话
				remarks:'',  //备注
				defaultFlag:'0',  //是否是收货地址
			};
			this.showVisible = false;
		},
		//获取收货地址
		getList(){
			this.userConsigneeList().then(res => {
				let {code,data} = res.data;
				if(code === '0'){
					this.list = data;
					this.list.forEach(item=>{
						if(item.defaultFlag==="1"){
							this.type="edit";
							item.value = [
								item.province,
								item.city,
								item.district
							]
							this.ruleForm = item;
						}
					});
				}
			})
		},
		//保存地址
		saveAddress(){
			if(this.type === "add" || this.type === "edit"){ //新增或修改
				this.$refs['ruleForm'].validate((valid) => {
					if(valid){
						var data = JSON.parse(JSON.stringify(this.ruleForm));
						data.province = data.value[0];  //省
						data.city = data.value[1];  //市
						data.district = data.value[2]; //区
						delete data.value;
						if(this.type === "add"){
							this.operation(this.addUserConsignee,data,'新增成功');
						}else if(this.type === 'edit'){
							this.operation(this.editUserConsignee,data,'修改成功');
						}
						this.getList();
					}
				})
			}else{
				this.cancel();
			}
		},
		operation(fn,data,text){
			fn(data).then(res => {
				let {code,data} = res.data;
				if(code === "0"){
					this.type = 'edit';
					ElMessage({
						type:'success',
						message:text,
					})
					this.ruleForm = data;
					this.ruleForm.value = [
						data.province,
						data.city,
						data.district
					]
					this.getList();
				}
			})
		},
	},
	computed: {
		getHeight() {
			return document.body.clientHeight / 8;
		},
	},
	watch: {
		modelValue(v) {
			this.show = v;
			this.activeName = '0'
			if (this.tableData.length === 0) {
				this.handleClick('0')
			}
			const params = {
				inquiryId: this.inquiryId,
				type: this.activeName
			}
			// this.tableData = []
			this.purchaseCartListCart(params).then(res => {
				let { data, code } = res.data;
				if (code === '0') {
					this.tableData = data;
				}
			})
		},
	},
}
</script>

<style scoped lang="less">
.i {
	font-size: 14px;
	padding: 10px 20px 20px 20px;
	position: relative;
	height: 500px;
	overflow-y: auto;

	.title-box {
		position: absolute;
		top: 15px;
		right: 15px;
		z-index: 50;

		.title-right-box {
			display: flex;
			align-items: center;
			cursor: pointer;
		}
	}

	.i-title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 0;

		.i-title-right {
			color: #999999;
			display: flex;
			align-items: center;
			cursor: pointer;

			p {
				font-size: 14px;
				margin-right: 4px;
			}
		}
	}

	.i-title-left {
		margin-bottom: 10px;
	}

	.i-content {
		height: 70vh;

		.g-info {
			display: flex;
			// overflow-x: auto;
			align-items: center;
			justify-content: space-between;

			.g-icon {
				img {
					width: 60px;
					height: 60px;
				}
			}

			.g-right {
				flex: 1;
				box-sizing: border-box;
				padding-left: 20px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.g-r-title {
					font-size: 14px;
					display: flex;

					.label {
						max-width: 100px;
						background: @dh-color;
						border-radius: 0 10px 10px 10px;
						color: #FFFFFF;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						font-size: 12px;
						padding: 0 8px;
						margin-left: 10px;
						height: 24px;
						box-sizing: border-box;
					}
				}

				.g-r-data {
					color: #666666;
					font-size: 12px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;

					span {
						margin: 0 10px;
					}
				}
			}
		}
	}

	.iu {
		width: 100%;
		height: 100%;
	}
	.box-item{
		border: 1px solid #d5dae0 !important;
	}
}</style>
